import { useFlagSettingsSplitEnabled } from "@/hooks/use-flag";
import { useMembership } from "@/hooks/use-membership";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import type { FC } from "react";
import { Navigate } from "react-router-dom";

/**
 * Redirects to the appropriate settings page based on the settings_split_enabled flag.
 * - Flag OFF: Redirect to /settings/profile (user settings first)
 * - Flag ON: Redirect to first org settings page (manage-organization for admins, members for non-admins)
 */
export const SettingsRedirect: FC = () => {
    const { value: settingsSplitEnabled, loading: flagLoading } = useFlagSettingsSplitEnabled();
    const { membership, isPending: membershipPending } = useMembership();

    if (flagLoading || membershipPending) {
        return null;
    }

    if (!settingsSplitEnabled) {
        return <Navigate to="/settings/profile" replace />;
    }

    // When flag is ON, redirect to first visible org settings page
    const isAdmin = membership?.userRole === OrganizationRole.ADMIN;
    const to = isAdmin ? "/settings/manage-organization" : "/settings/members";

    return <Navigate to={to} replace />;
};
